<section class="bg-white dark:bg-gray-900 h-[100vh]">
    <div class="flex items-center h-[100%]">
        <div class="mx-auto max-w-screen-md text-center">
            <h1 class="mb-6 text-8xl font-extrabold tracking-tight lg:text-9xl text-primary-600 dark:text-primary-500">404</h1>
            <p class="mb-6 text-3xl font-bold text-gray-900 md:text-4xl dark:text-white">Oops! The page you're looking for isn't here.</p>
            <p class="mb-6 text-lg font-light text-gray-500 dark:text-gray-400">It seems the page you’re trying to reach doesn't exist or has been moved. Don’t worry, let’s get you back on track.</p>
            <a href="/" class="inline-flex text-[#ffffff] items-center justify-center bg-[#162F4D] font-medium rounded-[5px] text-sm px-6 py-3 text-center dark:focus:ring-primary-900 no-underline">Return to Homepage</a>
        </div>
    </div>
</section>
